export const isValidJPEG = (data: Uint8Array) => {
  if (data.length < 4) {
    return false;
  }

  const startsWithSOI = data[0] === 0xff && data[1] === 0xd8;
  const endsWithEOI =
    data[data.length - 2] === 0xff && data[data.length - 1] === 0xd9;

  return startsWithSOI && endsWithEOI;
};

export const isMultipartFormData = <H extends Headers | Dictionary<string>>(
  headers: Nullish<H>,
) => {
  const contentType = headers
    ? headers instanceof Headers
      ? headers.get('content-type')
      : (headers['Content-Type'] ?? headers['content-type'])
    : null;

  return contentType === 'multipart/form-data';
};

export const isNumber = (value: any): value is number => {
  return typeof value === 'number' && !Number.isNaN(value);
};

export const isElementFactory =
  <
    I extends {
      new (): any;
      prototype: any;
    },
  >(
    instanceList: I[],
  ) =>
  <E extends HTMLElement | Element | EventTarget>(el?: Nullish<E>) =>
    instanceList.findIndex(instance => el instanceof instance) >= 0;

export const isButtonElement = <E extends HTMLElement | Element | EventTarget>(
  el?: Nullish<E>,
) =>
  isElementFactory([HTMLButtonElement])(el) ||
  (el instanceof Element && el.role === 'button');

export const isInputElement = <E extends HTMLElement | Element | EventTarget>(
  el?: Nullish<E>,
) =>
  isElementFactory([HTMLInputElement, HTMLTextAreaElement])(el) &&
  !(el as HTMLElement)?.isContentEditable;

export const isOutOfViewport = ({
  top,
  left,
  height,
  width,
}: {
  top: number;
  left: number;
  height: number;
  width: number;
}) =>
  top < 0 ||
  left < 0 ||
  top + height > window.innerHeight ||
  left + width > window.innerWidth;
